import Const from '@/helper/const'
import { custAxios } from './genericApi'

export default {
  addLog (data) {
    return custAxios().post(`${Const.API_BACKOFFICE}/log`, data)
  }
}
